module.exports = __webpack_public_path__ + "static/media/icon-defensive-shot.b5968031.svg";